export class EntityRelationship<NodeEntity, Relationship extends string> {
  constructor(
    public readonly type: Relationship,
    public readonly a: NodeEntity,
    public readonly b: NodeEntity,
  ) {}
}
